import { UploaderComponent } from '@shared/modules/uploader/containers/uploader/uploader.component';
import { Component } from '@angular/core';
import { CapturumButtonComponent } from '@capturum/ui/button';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { CapturumValidatorComponent } from '@capturum/ui/api';
import { TranslatePipe } from '@ngx-translate/core';
import { CapturumFileUploadComponent } from '@capturum/ui/file-upload';
import { TooltipComponent } from '@shared/components/tooltip/tooltip.component';

@Component({
  selector: 'app-image-uploader',
  templateUrl: './image-uploader.component.html',
  imports: [
    CapturumButtonComponent,
    ConfirmDialog,
    CapturumValidatorComponent,
    TranslatePipe,
    CapturumFileUploadComponent,
    TooltipComponent,
  ],
  styleUrls: ['./image-uploader.component.scss'],
})
export class ImageUploaderComponent extends UploaderComponent {}
